import getOr from '../../../utils/getOr';

// 2 is hard-coded value of FroalaEditor.ENTER_BR
var getEnterBR = getOr(2)('$.FroalaEditor.ENTER_BR');
var DENIED_ATTRS = [
// https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes
'accesskey', 'autocapitalize', 'autocomplete', 'class', 'contenteditable', 'contextmenu', 'dir', 'draggable', 'dropzone', 'exportparts', 'hidden', 'id', 'is', 'itemid', 'itemprop', 'itemref', 'itemscope', 'itemtype', 'lang', 'part', 'slot', 'spellcheck', 'style', 'tabindex', 'title', 'translate'];
var DENIED_TAGS = [
// list from https://developer.mozilla.org/en-US/docs/Web/HTML/Element
'a', 'abbr', 'acronym', 'address', 'applet', 'area', 'article', 'aside', 'audio',
// 'b',
'base', 'basefont', 'bdi', 'bdo', 'bgsound', 'big', 'blink', 'blockquote', 'body',
// 'br',
'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'command', 'content', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element',
// 'em',
'embed', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html',
// 'i',
'iframe', 'image', 'img', 'input', 'ins', 'isindex', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'listing', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'multicol', 'nav', 'nobr', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output',
// 'p',
'param', 'picture', 'plaintext', 'pre', 'progress', 'q', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'shadow', 'slot', 'small', 'source', 'spacer', 'span', 'strike',
// 'strong',
'style',
// 'sub',
'summary',
// 'sup',
'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'tt',
// 'u',
'ul', 'var', 'video', 'wbr', 'xmp', 'nextid'];
var TOOLBAR_BUTTONS = ['bold', 'italic', 'underline', 'superscript', 'subscript', '|', 'undo', 'redo', 'fullscreen'];
var RECORD_EDITOR_FROALA_CONFIG = {
  toolbarSticky: false,
  enter: getEnterBR(window),
  entities: '&quot;&amp;&apos;&lt;&gt;',
  placeholderText: '',
  heightMin: 106,
  plugins: ['fullscreen', 'entities'],
  toolbarButtons: TOOLBAR_BUTTONS,
  toolbarButtonsMD: TOOLBAR_BUTTONS,
  toolbarButtonsSM: TOOLBAR_BUTTONS,
  toolbarButtonsXS: TOOLBAR_BUTTONS,
  shortcutsEnabled: ['bold', 'italic', 'underline', 'undo', 'redo'],
  htmlAllowComments: false,
  htmlAllowedAttrs: [],
  htmlAllowedStyleProps: [],
  htmlAllowedTags: ['b', 'br', 'em', 'i', 'p', 'strong', 'sub', 'sup', 'u'],
  htmlExecuteScripts: false,
  pasteDeniedAttrs: DENIED_ATTRS,
  pasteDeniedTags: DENIED_TAGS,
  wordAllowedStyleProps: [],
  wordDeniedAttrs: DENIED_ATTRS,
  wordDeniedTags: DENIED_TAGS,
  wordPasteKeepFormatting: true,
  wordPasteModal: false
};
export default RECORD_EDITOR_FROALA_CONFIG;